<template>
  <form class="dropzone">
    <!-- Not displayed, just for Dropzone's `dictDefaultMessage` option -->
    <!-- However, the text here is actually displayed. -->
    <div id="dropzone-message" style="display: none">
      <div class="dropzone-title">
        {{ title }}
      </div>
      <div class="dropzone-info">
        {{ description }}
      </div>
      <div v-if="showDisclaimer" class="dropzone-disclaimer">
        {{ disclaimer }}
      </div>
    </div>

    <input v-for="(value, param) in additionalParams" :key="param" type="hidden" :name="param" :value="value">
  </form>
</template>

<script>
import Dropzone from 'dropzone'
import { inject } from 'vue'
import isPresent from '@/helpers/is-present'

Dropzone.autoDiscover = false

export default {
  props: {
    // List of MIME types or file extensions that are allowed.
    // Anything the user tries to upload will be checked against this list.
    acceptedFileTypes: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: false,
      default() {
        return inject('i18n').t('components.dropzone.title')
      }
    },
    description: {
      type: String,
      required: false,
      default() {
        return inject('i18n').t('components.dropzone.info')
      }
    },
    disclaimer: {
      type: String,
      required: false
    },
    additionalParams: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },

  data() {
    return {
      dropzone: null
    }
  },

  computed: {
    commonDropzoneOptions() {
      return {
        // If we specify a custom accept() function, the accepted file types (and max size if specified)
        // will be checked _before_ our accept() function is called.
        acceptedFiles: this.acceptedFileTypes.join(','),

        // Customize the wording
        dictDefaultMessage: document.querySelector('#dropzone-message').innerHTML
      }
    },

    showDisclaimer() {
      return isPresent(this.disclaimer)
    }
  }
}
</script>

<style lang="scss" scoped>
  @use "~friendship_styles/colors" as colors;

  .dropzone {
    background-color: #f7f7f7;
    min-height: 214px;
    border-top: 1px colors.$separator-gray solid;
    border-bottom: 1px colors.$separator-gray solid;
    cursor: pointer;

    ::v-deep(.dz-message) {
      text-align: center;
      color: colors.$dark-gray-text-color;

      .dz-button {
        border: none;
        background-color: transparent;
      }

      .dropzone-title {
        font-size: 24px;
        margin-top: 20px;
        margin-bottom: 20px;
        font-weight: bold;
      }

      .dropzone-info, .dropzone-disclaimer {
        color: #666666;
        font-size: 1rem;
        font-weight: bold;
        padding: 0 20px;
      }

      .dropzone-disclaimer {
        margin-top: 10px;
      }
    }

    ::v-deep(.dz-progress) {
      height: 30px;
    }

    ::v-deep(.dz-preview) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .dz-success-mark, .dz-error-mark {
        display: none;
      }
    }
  }
</style>

